// Boshliq (2026-09-05): telefon (< md, 768px) — antd Table o'rniga kartalar; desktop — o'zgarishsiz Table.
// Oddiy `<Table ... />` ishlatgan sahifalar uchun (TableExtended o'zi ichida shu rejimni qo'llaydi).
import React from "react"
import { TableProps } from "antd"
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint"
import MobileCards from "./MobileCards"
import StickyTable from "./StickyTable"

export function useIsMobile() {
  const bp = useBreakpoint()
  // birinchi render'da {} keladi — desktop deb hisoblaymiz (kartalar «miltillamasin»)
  return bp.md === false
}

export default function ResponsiveTable(props: TableProps<any> & { mobilePageSize?: number; mobileEmptyText?: React.ReactNode }) {
  const isMobile = useIsMobile()
  if (!isMobile) {
    const { mobilePageSize, mobileEmptyText, ...rest } = props
    return <StickyTable {...rest} />   // tog'a #4153 (+++ #4181): sarlavha va «Итого» joyida qotadi
  }
  const pg: any = props.pagination
  const pageSize = props.mobilePageSize ?? (pg && pg.pageSize ? pg.pageSize : pg === false ? 0 : 20)
  return (
    <MobileCards
      columns={(props.columns as any[]) || []}
      dataSource={props.dataSource}
      rowKey={props.rowKey as any}
      loading={!!props.loading}
      pageSize={pageSize}
      emptyText={props.mobileEmptyText ?? (props.locale as any)?.emptyText}
      rowClassName={typeof props.rowClassName === "function" ? (props.rowClassName as any) : undefined}
      // tog'a #3410: jadvaldagi qator bosish amali (onRow onClick/onDoubleClick) telefon kartochkasida ham ishlasin;
      // kartochka ichidagi tugma/havola/maydonga tegilsa — amal bajarilmaydi
      onRowClick={props.onRow ? (r: any, e?: any) => {
        const tg = e?.target as HTMLElement | undefined
        if (tg && typeof tg.closest === "function" && tg.closest("a,button,input,textarea,label,.ant-select,.ant-picker,.ant-checkbox-wrapper,.ant-input-number")) return
        const h: any = (props.onRow as any)(r, undefined) || {}
        ;(h.onClick || h.onDoubleClick)?.(e || { target: null })
      } : undefined}
    />
  )
}
